module.exports = __webpack_public_path__ + "img/Top-Users-by-Centrality-Rank-768x479.6068ba63.png";